import { submitForm, deleteAssessment } from './effects'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_NEW_FORM = 'GO_TO_NEW_FORM'
export const GO_TO_UPDATE_FORM = 'GO_TO_UPDATE_FORM'
export const GO_TO_INDEX = 'GO_TO_INDEX'
export const GO_TO_SHOW = 'GO_TO_SHOW'
export const GO_TO_DELETE = 'GO_TO_DELETE'
export const GO_BACK = 'GO_BACK'
export const MARK_ASSET_FOR_ASSESSMENT = 'MARK_ASSET_FOR_ASSESSMENT'
export const MARK_LIABILITY_FOR_ASSESSMENT = 'MARK_LIABILITY_FOR_ASSESSMENT'
export const MARK_RISK_PRODUCT_FOR_ASSESSMENT = 'MARK_RISK_PRODUCT_FOR_ASSESSMENT'
export const SUBMIT_FORM = 'SUBMIT_FORM'
export const DELETE_ASSESSMENT = 'DELETE_ASSESSMENT'
export const LOADING = 'LOADING'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),

  goToNewForm: (assessmentType) => () => {
    dispatch({
      type: GO_TO_NEW_FORM,
      payload: { assessmentType }
    })
  },
  goToIndex: () => {
    dispatch({
      type: GO_TO_INDEX
    })
  },
  goToShow: (assessmentType) => () => {
    dispatch({
      type: GO_TO_SHOW,
      payload: { assessmentType }
    })
  },
  goToDelete: (assessmentType) => () => {
    dispatch({
      type: GO_TO_DELETE,
      payload: { assessmentType }
    })
  },
  goToUpdateForm: (assessmentType) => () => {
    dispatch({
      type: GO_TO_UPDATE_FORM,
      payload: { assessmentType }
    })
  },
  goBack: () => {
    dispatch({
      type: GO_BACK
    })
  },


  submit: async (values, assessmentType) => {
    dispatch({
      type: LOADING
    })
    await submitForm(state, values, assessmentType)
    dispatch({
      type: SUBMIT_FORM,
      payload: { assessmentType }
    })
  },

  deleteAssessment: (assessmentType) => async () => {
    dispatch({
      type: LOADING
    })
    await deleteAssessment(state, assessmentType)
    dispatch({
      type: DELETE_ASSESSMENT
    })
  },
})
